import React, { useState } from "react";
import image from "../images"
import { NavLink } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import "../css/login.css"
import "../css/loading.css"
import RingLoader from "react-spinners/RingLoader"
import ReCAPTCHA from "react-google-recaptcha";




const Login = () => {

  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [captcha, setCaptcha] = useState('');
  const [busy, setBusy] = useState(false);
  

  const onChange = () => {
    setCaptcha(true)
  }


  const loginUser = async (e) => {
    e.preventDefault();
    setBusy(true)
    const res = await fetch("https://petme.onrender.com/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        email,
        password
      })

    });
    setBusy(false)

    const data = await res.json();

    if (res.status === 400 || !data) {
      window.alert(data.message);
    } else {
      localStorage.setItem("token", data.token);
      window.alert(data.message);
      navigate("/home");
    }

  }

  if(busy){
    return(
      <div className="loader-container" >
    <RingLoader color="#36d7b7" loading size={90} />
    <h1 className="loading-heading">Loading....</h1>
  </div>
    )
  }


  return (
    <div>
      <div class="login-bg_img"></div>
      <div class="login-div">
        <div class="login-background-content">
          <h1 class="log-in">Log In</h1>
          <p class="login-please-signin">Please Login to Continue</p>
          <form method='POST' class="form login-form">
            <input id="email" type="email" name="email" className="box user-login-box" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email address" />
            <input id="password" type="password" name="pasword" className="box user-login-box" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="password" />
            <ReCAPTCHA className="login-recaptcha" sitekey="6LfMrgonAAAAAKLie8JOmZT_LIcXwh4gKFhQj4v8" onChange={onChange} />
            {captcha && (<button id="submit" className="login-submit-btn" onClick={loginUser} >
              LOGIN
            </button>)}

            
          </form>
          <p class="or">or</p>
          <p class="login-with">You can login with</p>
          <button type="button" class="btn facebook"><img className="facebook-login" src={image.facebook} alt="facebook-icon" /></button>
          <button type="button" class="btn google"><img className="google-login" src={image.google} alt="google-icon" /></button>
          <button type="button" class="btn twitter"><img className="twitter-login" src={image.twitter} alt="twitter-icon" /></button>
          <NavLink className="forgotPassword-navlink" to="/forgotPassword"><p class="login-forgotPassword">Forgot Password?</p></NavLink>
          <p class="no-account">Don't have an account? <NavLink className="login-navlink" to="/signup"><span className="signup-link">Signup</span></NavLink></p>
        </div>
      </div>
    </div>
  )
}

export default Login